import type { CalendarEvent } from '@/features/calendar/public';
import { plannedToAnchorDate } from '@/shared/lib/datetime/planned-date';
import type { Task } from '../types';

export function taskToCalendarEvent(task: Task): CalendarEvent {
  const start = task.startDate ?? task.dueDate ?? null;
  const end = task.dueDate ?? task.startDate ?? null;
  return {
    id: task.id,
    title: task.title,
    start: start ? plannedToAnchorDate(start) : new Date(),
    end: end ? plannedToAnchorDate(end) : new Date(),
    allDay: true,
    type: 'task',
    source: 'internal',
    metadata: {
      status: task.status.type,
      priority: task.priority,
      assignee: task.assignee,
    },
  };
}
